module.exports = __webpack_public_path__ + "media/images/icons/twitter-6206ea58d28e6da1305e616d69890e11.svg";